import React, { Component } from 'react'
import { Button, Icon, notification } from 'antd'
import Parse from 'parse'
import Auth from '../../../../auth/Auth'
import { createConsolidatedOrderFromOrder } from './create-from-order'

export default class GenerateConsolidatedOrderButton extends Component {
  state = {
    loading: false,
  }

  componentDidMount() {
    const user = Parse.User.current()
    this.auth = new Auth(user)
    this.auth.init(() => this.forceUpdate())
  }

  canCreate = () => {
    return this.auth && this.auth.hasAction(['*', 'ConsolidatedOrderCreate'])
  }

  handleClick = async () => {
    const { formModule } = this.props
    const objectId = formModule.editParams && formModule.editParams[1]
    const orderJson = formModule.state.formRef || {}

    if (!objectId) {
      notification.warning({
        message: 'Salve o pedido antes',
        description: 'É preciso estar editando um pedido existente para gerar o consolidado.',
        placement: 'topLeft',
      })
      return
    }

    this.setState({ loading: true })
    notification.open({
      message: 'Gerando pedido consolidado',
      description: 'Aguarde enquanto o registro é criado...',
      key: 'creatingConsolidatedOrder',
      duration: 0,
      placement: 'topLeft',
      icon: <Icon type="loading" />,
    })

    try {
      const created = await createConsolidatedOrderFromOrder({
        ...orderJson,
        objectId,
      })
      notification.close('creatingConsolidatedOrder')
      notification.success({
        message: 'Pedido consolidado criado',
        description: `Código ${created.get('code')}`,
        placement: 'topLeft',
      })
      formModule.props.module.url_props.history.push(
        `/panel/pedido-consolidado/editar/${created.id}`
      )
    } catch (error) {
      notification.close('creatingConsolidatedOrder')
      notification.error({
        message: 'Erro ao gerar pedido consolidado',
        description: (error && error.message) || 'Tente novamente.',
        placement: 'topLeft',
      })
    } finally {
      this.setState({ loading: false })
    }
  }

  render() {
    if (!this.canCreate()) return null

    const objectId = this.props.formModule.editParams && this.props.formModule.editParams[1]
    if (!objectId) return null

    return (
      <Button
        icon="file-done"
        loading={this.state.loading}
        onClick={this.handleClick}
        style={{ marginRight: 10 }}
      >
        Gerar pedido consolidado
      </Button>
    )
  }
}
